import { HttpBackend } from '@angular/common/http';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';

export function HttpLoaderFactory(http: HttpBackend) {
  return new MultiTranslateHttpLoader(http, [
    { prefix: './assets/ermitsrl/commons/i18n/', suffix: '.json' }, //your lib assets
    { prefix: './assets/i18n/', suffix: '' }, //host app i18n
  ]);
}
